export default "__VITE_PUBLIC_ASSET__969a39b4__"